export default "__VITE_ASSET__DqOKsowl__"